import { PartnerAccountManagerDictionary } from 'types/i18n';
import { ISOCountries } from 'utils/isoCountries';
import { normalizeProfileLike } from 'utils/profileLikeUtils';

export const partnerAccountManagerDictionaryRu: PartnerAccountManagerDictionary = {
  header: {
    titleText: 'Мой профиль',
    signOutActionText: 'Выйти из аккаунта',
    accountTabText: 'Анкета и реквизиты',
    financesTabText: 'Мои финансы',
  },
  summaryScreen: {
    editProfileActionText: 'Редактировать анкету',
    editPasswordActionText: 'Редактировать пароль',
    summaryTitleValue(partnerProfile) {
      const text = normalizeProfileLike(partnerProfile).toFullName();

      const textWithLineBreak = text.replace(' ', '\n');

      return textWithLineBreak;
    },
    locatonValue(country, city) {
      const countryName = ISOCountries.getName(country, 'ru');

      return `${countryName}, ${city}`;
    },
  },
  passwordEditorScreen: {
    titleText: 'Редактирование пароля',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },
  profileEditorScreen: {
    titleText: 'Редактирование анкеты',
    submitActionText: 'Сохранить изменения',
    cancelActionText: 'Отмена',
  },
};
